<template>
  <div v-show="isMinimize && !isPopout" class="swaychat-chatbox-container swaychat-zoomIn swaychat-minimize-window"
  :class="{
    'swaychat-contrast-dark' : isLightDark == 'dark',
    'swaychat-contrast-light' : isLightDark == 'light',
    'swaychat-hide': isTempHidden || isBootHidden
  }"
  >
    <header-component></header-component>
  </div>
</template>

<script>
import HeaderComponent from './HeaderComponent.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    HeaderComponent
  },
  computed: {
    ...mapGetters([
      'isMinimize',
      'isPopout',
      'isLightDark',
      'isTempHidden',
      'isBootHidden'
    ])
  }
}

</script>
